<template>
  <v-card>
   <v-toolbar color="blue-grey white--text">
      <v-toolbar-title class="white--text">ข้อมูลบุคคล</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-title class="subheading white--text"></v-toolbar-title>
    </v-toolbar> 

    <v-card-text :class="reportType === 'A' ? 'green lighten-5' : '' ">
      <v-container fluid grid-list-md>
        <v-layout row wrap>
          <v-flex xs12 md12 d-flex>
            <v-radio-group v-model="reportType">
              <strong>
                <v-radio label="ข้อมูลประวัติบุคคล" value="A"></v-radio>
              </strong>
            </v-radio-group>
          </v-flex>
          <v-flex xs12 md6 d-flex offset-xs1 offset-md1>
            <v-autocomplete
              :loading="loading"
              :items="personItems"
              label="ชื่อ นามสกุล"
              v-model="params.person"
              item-value="id"
              item-text="fullname"
              outline
              hide-details
              clearable
              @change="active = true"
              :disabled="reportType === 'B'"
            ></v-autocomplete>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-text :class="reportType === 'B' ? 'green lighten-5' : '' ">
      <v-container fluid grid-list-md>
        <v-layout row wrap>
          <v-flex xs12 md12 d-flex>
            <v-radio-group v-model="reportType">
              <strong>
                <v-radio label="ข้อมูลอื่นๆ" value="B"></v-radio>
              </strong>
            </v-radio-group>
          </v-flex>
          <v-flex xs12 md3 d-flex>
            <v-select
              :loading="loadingAcademicYear"
              :items="academicYearItems"
              label="ปี/ภาคการศึกษา"
              v-model="params.academicYear"
              item-value="id"
              item-text="yearSemester"
              outline
              hide-details
              :disabled="reportType === 'A'"
              @change="active = true"
            ></v-select>
          </v-flex>
          <v-flex xs12 md5>
            <v-select
              :items="reportItems"
              label="กรุณาเลือก"
              v-model="report"
              item-value="value"
              item-text="text"
              outline
              hide-details
              :disabled="reportType === 'A'"
              @change="active = true"
            ></v-select>
          </v-flex>
          <v-flex xs12 sm12 md4>
            <v-radio-group v-model="params.insider" row :disabled="reportType === 'A'">
              <v-radio label="บุคคลภายใน" value="true"></v-radio>
              <v-radio label="บุคคลภายนอก" value="false"></v-radio>
            </v-radio-group>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>

    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-slide-x-transition mode="out-in">
        <v-btn
          color="info"
          target="_new" 
          :href="reportUrl"
          v-if="active"
        >
          <v-icon left dark>cloud_download</v-icon> ส่งออกข้อมูล
        </v-btn>
      </v-slide-x-transition>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import config from '@/config/index'
import swal from 'sweetalert2'
import moment from 'moment'

export default {
  data () {
    return {
      search: null,
      select: null,
      active: false,
      disabled: true,
      loading: false,
      report: null,
      reportItems: [
        { value: 'educations', text: 'ข้อมูลการศึกษา' },
        { value: 'works', text: 'ข้อมูลการทำงาน' },
        { value: 'portfolios', text: 'ข้อมูลผลงานวิจัย/ผลงานทางการศึกษา' },
        { value: 'expertises', text: 'ข้อมูลสาขา/เรื่องที่เชียวชาญ' },
        { value: 'teachings', text: 'ข้อมูลประสบการณ์การสอนนอกเหนือจากวิชาทั่วไป' }
      ],
      loadingAcademicYear: false,
      academicYearItems: [],
      params: {
        academicYear: null,
        person: null,
        insider: 'true'
      },
      reportType: 'A'
    }
  },
  mounted () {},
  computed: {
    ...mapGetters ({
      token: 'token',
      personItems: 'person/personItems'
    }),
    reportUrl () {
      return this.reportType === 'A' ? this.printoutProfile : this.printoutReport
    },
    printoutProfile () {
      return `${config.serverURI}/persons/printout/profile/${this.params.person}?access_token=${this.token}`
    },
    printoutReport () {
      return `${config.serverURI}/persons/printout/${this.report}?academicYear=${this.params.academicYear}&insider=${this.params.insider}&access_token=${this.token}`
    }
  },
  mounted () {
    this.fetchAcademicYears ()
    this.loading = true
    this.$store.dispatch('person/fetchPersonItems')
  },
  methods: {
    date (val) {
      return val ? this.$options.filters.formatFullDate(val) : null
    },
    fetchAcademicYears () {
      this.loadingAcademicYear = true
      this.$store.dispatch("academicYear/loadItems")
        .then((response) => {
          this.academicYearItems = response.data
          this.loadingAcademicYear = false
        }).catch((error)=>{
          console.log('reload', error)
          this.loadingAcademicYear = false
        })
    }
  },
  watch: {
    personItems (val) {
      if(val) this.loading = false
    },
    'params': {
      handler (val) {
       
      },
      deep: true
    },
    reportType (val) {
      if(val) this.active = false
      if(val === 'A' && this.params.person !== null) this.active = true
      if(val === 'B' && this.report !== null) this.active = true
    }
  }
}
</script>

<style scoped>
  .boxes {
    min-width: 400px;
  }
</style>


// WEBPACK FOOTER //
// src/components/reports/person/index.vue